var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table-responsive base_report_table"},[_c('table',{staticClass:"table"},[_c('thead',[_vm._t("head")],2),_c('tbody',[_vm._t("body")],2),(_vm.showFoot)?_c('tfoot',[_vm._t("foot",function(){return [_vm._m(0)]})],2):_vm._e()])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('tr',[_c('td',[_vm._v("Mark")]),_c('td',[_vm._v("Otto")])])
}]

export { render, staticRenderFns }